// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rwEp","footer":"styles_footer__1BqY3","passCodeTooltip":"styles_passCodeTooltip__qJe1P"};